import React, { useContext, useEffect, useState } from "react";
//import classes from "./pricingDropdowns.module.scss";
import classes from "../dashboardComponents/DashboardComponents.module.scss";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpIcon from '@mui/icons-material/Help';
import { OrgIdContext } from "../../store/orgId_context";
import { useTranslation } from "react-i18next";
import Button from "../UI/Button";
import { Dialog, DialogActions, DialogContent, DialogTitle, Switch, LinearProgress } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import { useQuery } from "@tanstack/react-query";
import { DDD } from "../../lib/ddd/ddd";
import visa from '../../assets/visad.png';
import mastercard from '../../assets/mastercardd.png';
import diners from '../../assets/dinersclubd.png';
import maestro from '../../assets/mestrod.png';
import visaelectron from '../../assets/visaelectrond.png';
import CurrencyTextField from '@lupus-ai/mui-currency-textfield'

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const UnscheduledCardMethod = ({card, onDeleteClick}) => {
    const {aboutOrgId, sessionInfo, setSessionInfoHandler } = useContext(OrgIdContext);
    const [fungData, setFungData] = useState();
    const [details, setDetails] = useState();
    const {t} = useTranslation();

    useEffect(() => {
        if(!card || !card.Response) return;
        try{
            let data = JSON.parse(card.Response);
            setFungData(data);
            const ev = data?.events?.find((e) => {return e?.resourceType === "TX" && e?.status === "AUTHORIZED"});
            setDetails(ev);
        }catch{}
    }, [card]);

    const getCardImage = () => {
        switch(details?.details?.card?.brand?.toLowerCase()){
            case "visa":
                return <img src={visa} alt="visa" style={{maxHeight:"35px"}}/>;
            case "mastercard":
                return <img src={mastercard} alt="visa" style={{maxHeight:"35px"}}/>;
            case "diners":
                return <img src={diners} alt="visa" style={{maxHeight:"35px"}}/>;
            case "maestro":
                return <img src={maestro} alt="visa" style={{maxHeight:"35px"}}/>;
            default:
                return <div className="fw-bold fs-5">{details?.details?.card?.brand}</div>;
        }
    }

    return (<>
        <div className={`ms-2 ${classes["card-container"]}`} style={{maxWidth:"400px", minWidth:"350px", position:"relative"}}>
            <div style={{position:"absolute", top:"2px", right : "5px"}}>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id={`tooltip-top`}>
                            {t("Forget this payment method")}
                        </Tooltip>
                    }
                >
                    <div className={`fs-8 ${classes.cardForger}`} onClick={() => onDeleteClick(card)}>{t("Delete")}</div>
                </OverlayTrigger>
            </div>
            <Row >
                <Col className="col-2 align-content-center">
                    {getCardImage()}
                </Col>
                <Col className="fs-7 ms-2">
                    {details && <>
                        <div className="d-flex">
                            <div>{details?.details?.card?.cardholderName}</div>
                        </div>
                        <div className="d-flex">
                            <div>{t("Expires")}: {details?.details?.card?.expiryMonth}/{details?.details?.card?.expiryYear}</div>
                            <div className="ms-auto">&#9679;&#9679;&#9679;&#9679;{details?.details?.card?.lastFour}</div>
                        </div>
                    </>}
                </Col>
            </Row>
        </div>
        </>);
};

export default UnscheduledCardMethod;
